import { render, staticRenderFns } from "./VueLink.vue?vue&type=template&id=15bbc774&scoped=true&"
import script from "./VueLink.vue?vue&type=script&lang=js&"
export * from "./VueLink.vue?vue&type=script&lang=js&"
import style0 from "./VueLink.vue?vue&type=style&index=0&id=15bbc774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bbc774",
  null
  
)

component.options.__file = "VueLink.vue"
export default component.exports